import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
@Component({
  template: `
    <ion-list style="margin: 0px 0 0px !important;">
      <ion-item class="filterDropDown">
        <ion-label>{{ "following" | translate }}
        <img item-start src="assets/img/football/icon-follow-s.png" style="height: 1.2rem; padding-left:3px; margin: 0px;" />
        </ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="subscribeFilter.isSubscribing" (click)="updateOption(true, false)" mode="md"></ion-checkbox>
      </ion-item>
      <ion-item class="filterDropDown">
        <ion-label>{{ "follower" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="subscribeFilter.isSubscribed" (click)="updateOption(false, true)" mode="md"></ion-checkbox>
      </ion-item>
    </ion-list>
  `
})
export class SubscribePopoverPage {
  subscribeFilter: SubscribeFilter;
  optionSubject: BehaviorSubject<SubscribeFilter>;

  constructor(public viewCtrl: ViewController, private navParams: NavParams) {
  }

  ngOnInit() {
    this.subscribeFilter = this.navParams.get('subscribeFilter');
    this.optionSubject = this.navParams.get('optionSubject');
  }

  updateOption(isSubscribing: boolean, isSubscribed: boolean) {
    if (isSubscribing) {
      this.subscribeFilter.isSubscribing = !this.subscribeFilter.isSubscribing;
    } else if (isSubscribed) {
      this.subscribeFilter.isSubscribed = !this.subscribeFilter.isSubscribed;
    }
    this.optionSubject.next(this.subscribeFilter);
  }
}

export class SubscribeFilter {
  isSubscribing: boolean;
  isSubscribed: boolean;

  constructor(isSubscribing : boolean, isSubscribed: boolean) {
    this.isSubscribing = isSubscribing;
    this.isSubscribed = isSubscribed;
  }

  isEnabled(): boolean {
    return this.isSubscribing || this.isSubscribed;
  }

  getSubscribeType(): number {
    return this.isSubscribing ? 1 : -1;
  }

  getSubscriberType(): number {
    return this.isSubscribed ? 1 : -1;
  }
}



// WEBPACK FOOTER //
// ./src/pages/leader-board/subscribe-popover.ts